import React from 'react';
import PropTypes from 'prop-types';

import {
  CuiDescriptionLayout,
  CuiPage,
  CuiPageTitle,
  CuiTextBlock,
} from '../../components';

export const ChapterPage = ({ title, children, ...rest }) => (
  <CuiPage {...rest}>
    <CuiPageTitle>{title}</CuiPageTitle>

    <CuiDescriptionLayout>
      <CuiTextBlock>{children}</CuiTextBlock>
    </CuiDescriptionLayout>
  </CuiPage>
);

ChapterPage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./ui/partials/chapterPage/ChapterPage.js